import { FC } from 'react';

import { useNotices } from '@/shared/providers/notices';
import { copy } from '@/shared/utils/misc';

import { Icon } from '../uikit/Icon';

type CopyButtonProps = {
  text: string;
  successMessage?: string;
  errorMessage?: string;
};

export const CopyButton: FC<CopyButtonProps> = ({ text, successMessage, errorMessage }) => {
  const notices = useNotices();

  const handleCopyAddress = async () => {
    try {
      await copy(text);
      notices.success(successMessage ?? 'Copied to clipboard');
    } catch (e) {
      notices.error(errorMessage ?? 'Failed to copy');
    }
  };

  return <Icon name="copy-simple" onClick={handleCopyAddress} style={{ cursor: 'pointer' }} />;
};
